import { memo } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Navigation } from '../../components/navigation';

const Organisations_ = () => {
  return <Outlet />;
};

export const Organisations = memo(Organisations_);
